// extracted by mini-css-extract-plugin
module.exports = {"spinner":"ccfda6eb9f--spinner--YYHWw","circle-spin":"ccfda6eb9f--circle-spin--Sbn3c"};